import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustItems = [
    {
      icon: 'Shield',
      text: 'SSL Güvenli Bağlantı',
      color: 'text-success'
    },
    {
      icon: 'Lock',
      text: 'Verileriniz Korunur',
      color: 'text-primary'
    },
    {
      icon: 'CheckCircle',
      text: 'Türkiye\'de Kayıtlı',
      color: 'text-secondary'
    }
  ];

  const paymentMethods = [
    { name: 'Visa', icon: 'CreditCard' },
    { name: 'Mastercard', icon: 'CreditCard' },
    { name: 'Troy', icon: 'CreditCard' }
  ];

  return (
    <div className="w-full space-y-6 md:space-y-8 lg:space-y-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
        {trustItems?.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-3 p-3 md:p-4 lg:p-5 bg-muted/50 rounded-lg md:rounded-xl transition-smooth hover:bg-muted"
          >
            <div className={`${item?.color}`}>
              <Icon name={item?.icon} size={20} />
            </div>
            <span className="text-xs md:text-sm lg:text-base font-medium text-foreground">
              {item?.text}
            </span>
          </div>
        ))}
      </div>
      <div className="border-t border-border pt-6 md:pt-7 lg:pt-8">
        <p className="text-xs md:text-sm text-muted-foreground text-center mb-4 md:mb-5 lg:mb-6">
          Güvenli Ödeme Yöntemleri
        </p>
        <div className="flex items-center justify-center gap-4 md:gap-5 lg:gap-6">
          {paymentMethods?.map((method, index) => (
            <div
              key={index}
              className="flex items-center gap-2 px-3 md:px-4 lg:px-5 py-2 md:py-3 bg-card border border-border rounded-md md:rounded-lg"
            >
              <Icon name={method?.icon} size={18} className="text-muted-foreground" />
              <span className="text-xs md:text-sm font-medium text-foreground">
                {method?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;